<div id="sright_product_box_inline" class="none">
  <div class="border border-gray-300 rounded-l-lg bg-white shadow-md">
    <ng-container *ngIf="!hide_this_box">
      <div class="flex items-start space-x-3 p-4">
        <img loading="lazy" class="w-20 lg:max-w-36" src="{{product.img_spotlight}}" alt="{{product.name}}" />
        <div class="flex flex-col space-y-2">
          <p class="w-48 font-semibold text-sm text-pink-800 leading-3 lg:text-base lg:leading-5">{{product.name}}</p>
          <div>
            <div class="flex flex-col">
              <ng-container *ngIf="product.price_discount_percent != null">
                <p class="text-xs text-gray-600 lg:text-[.7rem] line-through" *ngIf="product.price_compare_at > 0">R$ {{product.price_compare_at | number:'1.2-2'}}</p>
              </ng-container>
              <p class="text-sm font-semibold text-gray-700 lg:text-base">R$ {{product.price | number:'1.2-2'}}</p>
            </div>
          </div>
          <div class="flex items-center space-x-2">
            <div>
              <label>&#160;</label>
              <input type="number" min="1" class="focus:outline-none border-2 border-gray-200 rounded-lg w-20 h-12 text-center font-semibold text-sm" value="1" (change)="clientMarketplaceCartProductQuantityChange($event)" />
            </div>
            <div class="col-12 col-md-4">
              <label>&#160;</label>
              <ng-container *ngIf="product.inventory_quantity_available > 0 && product.product_status == 'active'">
                <button class="bg-[#FFBE0B] p-2 text-black font-medium text-sm rounded-lg lg:p-4 hover:bg-amber-500" (click)="clientMarketplaceCartProductServiceCreate()">Comprar</button>
              </ng-container>
              <ng-container *ngIf="product.inventory_quantity_available < 1 || product.product_status == 'inactive'">
                <p class="text-gray-700 font-semibold text-sm">Produto Indisponível</p>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <div class="flex items-center space-x-4 p-2 justify-end">
      <div class="flex items-center space-x-2 text-xs cursor-pointer lg:text-[.7rem]" (click)="scrollIntoView()" *ngIf="!hide_this_box">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round" d="M5 15l7-7 7 7" />
        </svg>
        <a>Voltar ao Topo</a>
      </div>
      <div class="flex items-center space-x-2 text-xs cursor-pointer lg:text-[.7rem]" (click)="hide_this_box = !hide_this_box">
        <ng-container *ngIf="!hide_this_box">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
            />
          </svg>
          <button>Esconder</button>
        </ng-container>
      </div>
      <ng-container *ngIf="hide_this_box">
        <div class="flex items-center space-x-2 cursor-pointer" (click)="hide_this_box = !hide_this_box">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-amber-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
          </svg>
          <p class="text-xs font-semibold uppercase text-pink-800 lg:text-sm">Comprar</p>
        </div>
      </ng-container>
    </div>

    <div id="container-block" [ngClass]="{'none': !productHasBeenBought}">
      <div>
        <div id="container">
          <div>
            <div class="text-center px-6">
              <p class="font-bold text-lg text-pink-800 py-4">Adicionado ao seu Carrinho</p>
              <p class="font-medium text-sm text-gray-800 text-center">{{inventoryQuantity}} x {{product.name}}</p>
            </div>
          </div>
          <div class="px-6">
            <div class="mt-4 flex justify-center mb-2">
              <button class="bg-amber-400 rounded-full h-10 w-44" (click)="productHasBeenBought = !productHasBeenBought"><p class="text-white text-sm font-semibold">Continuar comprando</p></button>
            </div>
          </div>
          <ng-container *ngIf="cart?.client_marketplace_cart_uid">
            <div class="">
              <div class="col-12 align-items-center text-center py-4">
                <a [routerLink]="['/p/checkout']" [queryParams]="{uid: cart.client_marketplace_cart_uid, one_click_buy: true}"><strong>Finalizar compra</strong></a> | <a [routerLink]="['/p/cart']" [queryParams]="{uid: cart.client_marketplace_cart_uid}">Carrinho</a>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
